<template>
    <div>
        <Modal
            :value="showModel && isD"
            :title="title"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="cancel"
            @on-visible-change="openOrClose"  :styles="{'top':'20%','min-width':'700px'}">
    
            <div v-if="roleType==1 && showForm" style="text-align: right;cursor: pointer;margin-bottom: 20px;" @click="getLog">{{showLog?'关闭记录':'查看记录'}}</div>
            
            <div v-show="!showLog && showForm">
                <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            
                   <FormItem :label="$t('deviceManage.dealerModel.Dealer')" prop="dealerId"  style="width: 500px" class="ivu-form-item-required">
                       <SearchSelectRecycle ref="dealerRef" refName="dealerRef"   :url="searchDealerUrl" listName="dealersList" labelName='companyName'  :selectUrlQuery='{page:1,limit:10000}'  isMultiple='2'  valName='id' keyword="companyName" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValNew($event,'dealerId')"></SearchSelectRecycle>
                    </FormItem>
        
                   <FormItem :label="$t('deviceManage.dealerModel.Order')" prop="orderId"  style="width: 500px" class="ivu-form-item-required">
                       <SearchSelectRecycle ref="orderRef" refName="orderRef" :needName="$t('deviceManage.dealerModel.noOrder')"  :url="searchOrderUrl"  labelName='orderName'  :selectUrlQuery='selectUrlQuery_order'  isMultiple='2'  valName='id' keyword="orderName" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValNew($event,'orderId')"></SearchSelectRecycle>

                    </FormItem>
        
                    <FormItem :label="$t('deviceManage.dealerModel.Basic_type')" prop="basic"  style="width: 500px" class="ivu-form-item-required">
                         <Input type="text" v-model.trim="formData.baseType" disabled :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
    
                     <FormItem :label="$t('deviceManage.manageModel.titleName.Remark')" prop="remark"  style="width: 500px">
                        <Input  maxlength="100" show-word-limit type="textarea" v-model.trim="formData.remark" :placeholder="$t('inputPlaceholder')" ></Input>
                    </FormItem>
        
                    <FormItem>
                        <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                        <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
                    </FormItem>
                </Form>
            </div>
            <div v-if="showLog">
                <Table :columns="titleName" :loading="loadingLog" :data="tableList.tableData" ref="selection"></Table>
                <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :age-size-opts="[5,10]" placement="top" class="pages"/>
    
            </div>
    
        </Modal>
    </div>
    </template>
    <script>
    /**
     * 弹框
     * @param showModel boolean 对话框开关 true false
     * @param fn function 回调函数
     * @param type Number 类型 1添加 2编辑
     * @param editFormData Object 编辑时的数据
     */
    import common from '@/common/common';
    import SearchSelect from '../../common/selectList.vue';
    import SearchSelectRecycle from './selectListRecycleDealerMove.vue'; 
    import moment from 'moment';
    import { mapState } from 'vuex'
        export default {
            props: {
                showModel: Boolean,
                isD: Boolean,
                fn:Function,
                type:Number,
                editFormData:Object,
                showForm:{
                    type: Boolean,
                    default: true
                },
            },
            name: "Model3",
            components: {
                SearchSelect,
                SearchSelectRecycle
            },
            data() {
                return {   
                    disabled: false,//禁用确定按钮
                    title: '',//弹框标题
                    formData: {//表单数据
                       id:'',
                       dealerId:'',
                       orderId:'',
                       baseType:'',
                       deviceId:'',
                       remark:''
                    },
                    selectUrlQuery_order:{
                        baseType:'',
                        dealerId:''
                    },
                    showLog:false,
                    loadingLog:false,
                    tableList:{//表格组
                        paging:true,
                        tableData: [],//表格数据
                        tableDataAll:[]
                    },
                    page:{//分页排序
                        total:0,//总条数
                        pageSize:10,//每页条数
                        current:1,//当前页
                        key:'createdAt',
                        order:'desc'
                    },
                    isInitializing: false, // 初始化标志位
                }
            },
            watch:{
                showModel(val){
                    if(val){
                        
                    }
                }
            },
            computed:{
                searchDealerUrl(){
                    return this.config.urlArray.dealerpageList
                },
                searchOrderUrl(){
                    return this.config.urlArray.orderShow
                },
                ...mapState(['local','selectId']),
                roleType(){
                     let res = '2'
                       if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
                           res = this.$store.state.uInfo.roleType
                       }
                       return res
                },
                ruleCustom(){
                    return {//验证
                        dealerId: [
                            {required: true, message: this.$t('required'),trigger: 'change' },
                        ],
                        orderId: [
                            {required: true, message: this.$t('required'),trigger: 'change' },
                        ]
                    }
                } ,
                titleName(){
                    // 移动的时间，上一个经销商，上一个订单，当前经销商，当前订单，备注。
                    return [
                       {
                          title: this.$t('deviceManage.dealerModel.titleName.moveTime'),
                          'title-zh-CN':'移动日期',
                          'title-en-US':'modifyDate',
                          key: 'modifyDate;',
                          sortable: false,
                          minWidth: 230,
                          render:(h, params)=>{
                             let stext = moment(params.row.modifyDate*1).format('YYYY-MM-DD HH:mm:ss')
                              return h('div',stext || '')
                         }
                       },
                       {
                          title:this.$t('deviceManage.dealerModel.titleName.currentDealerID'),
                          'title-zh-CN':'当前经销商ID',
                          'title-en-US':'nowDealerId',
                          key: 'nowDealerId',
                          sortable: false,
                          minWidth: 120,
                      },
           
                      {
                          title: this.$t('deviceManage.dealerModel.titleName.currentOrderID'),
                          'title-zh-CN':'当前订单ID',
                          'title-en-US':'nowOrderId',
                          key: 'nowOrderId',
                          minWidth: 150,
                      },
                      {
                          title: this.$t('deviceManage.dealerModel.titleName.currentOrderName'),
                          'title-zh-CN':'当前订单名称',
                          'title-en-US':'nowOrderName',
                          key: 'nowOrderName',
                          minWidth: 150,
                      },
                       {
                          title: this.$t('deviceManage.dealerModel.titleName.previousDealerID'),
                          'title-zh-CN':'上一个经销商ID',
                          'title-en-US':'beforeDealerId',
                          key: 'beforeDealerId',
                          sortable: false,
                          minWidth: 120
                      },
                       {
                          title: this.$t('deviceManage.dealerModel.titleName.previousOrderID'),
                          'title-zh-CN':'上一个订单ID',
                          'title-en-US':'beforeOrderId',
                          key: 'beforeOrderId',
                          sortable: false,
                          minWidth: 150
                      },
                       {
                          title: this.$t('deviceManage.dealerModel.titleName.previousOrderName'),
                          'title-zh-CN':'上一个订单名称',
                          'title-en-US':'beforeOrderName',
                          key: 'beforeOrderName',
                          sortable: false,
                          minWidth: 150
                      },
                    
                      {
                          title: this.$t('deviceManage.dealerModel.titleName.remark'),
                          'title-zh-CN':'备注',
                          'title-en-US':'remark',
                          key: 'remark',
                          minWidth: 200
                      }
                   ]
                }
    
            },
            created(){
               
            },
            methods: {
                getLog(){
                    this.showLog = !this.showLog
                    if(this.showLog){
                        this.getData(); 
                    }else{
                        this.clearLog()
                    }
    
                },
                changePage(nowpage) {//切换分页
                    this.page.current = nowpage;
                    if(this.tableList.paging){
                        this.getData()          
                    }else{
                        this.getDataPage()  
                    }
                },
                changeSize(nowSize) {//切换每页显示条数
                    this.page.pageSize = nowSize
                    this.page.current = 1
                    if(this.tableList.paging){
                        this.getData()          
                    }else{
                        this.getDataPage()  
                    }
                },
                getData(){
                    let  params = {
                            page: this.page.current,
                            limit: this.page.pageSize,
                            sortfield: this.page.key,
                            ascDesc: this.page.order,
                            serialNumber:this.editFormData.serialNumber
                        }
                    
                    // Object.assign(params,this.searchObj)
                   
                    
                    this.loadingLog = true
        
                    this.axios.post(this.config.urlArray.getDeviceChangeDealerLog,params).then((result) => {
                        common.ajaxMsg(result.data,false,()=>{
                            let resData = result.data.data
    
                            if(resData){
                               this.tableList.tableDataAll  =  resData
                               if(!resData?.meta){//分页不生效
                                    this.tableList.paging = false
                                    this.page.total = resData.length
                                    this.getDataPage()
                                }else{
                                    //处理数组
                                    this.tableList.tableData  = resData
                                    this.page.total = resData.meta.count
                                }
                            }
    
                            this.loadingLog = false
                        });
                    }).finally((err) => {
                        this.loadingLog = false
                    });
                },
                getDataPage(){
                    let start = (this.page.current-1)*this.page.pageSize
                    let end = (this.page.current)*this.page.pageSize
                    let key =  this.page.key
                    let order = this.page.order
    
                    this.tableList.tableDataAll.sort((a, b) => {
                      const valA = a[key]
                      const valB = b[key]
                    
                      if (valA == null || valB == null) return 0 // 空值不排序
                    
                      if (typeof valA === 'number' && typeof valB === 'number') {
                        return order === 'asc' ? valA - valB : valB - valA
                      } else {
                        return order === 'asc'
                          ? String(valA).localeCompare(String(valB))
                          : String(valB).localeCompare(String(valA))
                      }
                    })
    
                    this.page.total = this.tableList.tableDataAll.length
                    this.tableList.tableData = this.tableList.tableDataAll.slice(start,end)
    
                },
                clearLog(){
                    this.page.current = 1
                    this.page.pageSize = 10
                    this.tableList.tableData  = []
                    this.tableList.tableDataAll  = []
                    this.tableList.paging  = true
                    this.loadingLog = false
                    this.showLog = false
                },
                setSelectValNew(e,key){
    
                    let obj = {dealerId:'id',orderId:'id'}
                    if(e){
                         this.formData[key] = e[obj[key]]+''
                    }else{
                         this.formData[key] = ''
                    }
    
                    if(key=='dealerId' && !this.isInitializing){
                        this.formData.orderId = ''
                        this.selectUrlQuery_order.dealerId = e?.[obj[key]]?e?.[obj[key]]+'':''
                        if(this.selectUrlQuery_order.dealerId){
                            this.$refs.orderRef.getData()
                        }else{
                            this.$refs.orderRef.clearVal()
                        }
                    }
    
                },
                openOrClose(value) {
                    if(value === true) {
                        
                        if(this.showForm==false){
                            this.title = `${this.$t("deviceManage.MoveLog")} ( ${this.editFormData.serialNumber} )`
                            this.getLog()
                            return
                        }

                        this.title = `${this.$t('deviceManage.dealerModel.title')} ( ${this.editFormData.serialNumber} )`
    
                        for (let key in this.editFormData) {
                             if (this.formData.hasOwnProperty(key)) {
                                 this.formData[key] = this.editFormData[key]
                             }
                             
                             if (this.selectUrlQuery_order.hasOwnProperty(key)) {
                                 this.selectUrlQuery_order[key] = this.editFormData[key]
                             }
                        }
    
    
                        this.formData.dealerId = this.editFormData.dealerId+''
                        this.formData.orderId = this.editFormData.orderId+''
    
                        
                
                        this.$nextTick(async ()=>{//select赋值
                            this.isInitializing = true; // 标记为初始化中
                            await this.$refs.dealerRef.setDefVal({
                                id:Number(this.formData.dealerId),
                            })
                            this.isInitializing = false; // 重置标志

                            await this.$refs.orderRef.setDefVal({
                                id:Number(this.formData.orderId),

                            })
    
                            // this.$refs.dealerRef.setDefVal(Number(this.formData.dealerId))
                            // this.$refs.orderRef.setDefVal(Number(this.formData.orderId))
                        });   
       
                         
                    } else {
    
                        this.$refs.dealerRef.clearVal();
                        this.$refs.orderRef.clearVal();
                        this.resetForm();//重置表单
                    }
                },
                subData(name) {//提交表单
         
                    this.$refs[name].validate((valid) => {
                        if (valid) {
                            // console.log(this.formData)
                            this.disabled = true;        
                            let url = this.config.urlArray.deviceGroupsMoveDealer
                            let params = {
                                dealerId:this.selectId,
                                orderId:this.formData.orderId,
                                deviceId:this.formData.deviceId,
                                remark:this.formData.remark,
                            }
                     
                            this.axios.post(url, params).then((result) => {
                              
                                common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                    this.resetForm();//重置表单
                                    this.fn()
                                },()=>{ this.disabled = false;})
                                
                            }).catch((err) => {
                                this.disabled = false;
                            });
                            
                        }
                    })
                },
                cancel() {//对话框关闭
                    this.resetForm()
                    this.$emit('update:showModel',false);
                },
                resetForm() {//重置表单
                    this.$refs.formData.resetFields();//重置表单
                    Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                    Object.keys(this.selectUrlQuery_order).forEach(key=>{this.selectUrlQuery_order[key]=''})
                    this.clearLog()
                    this.disabled = false;//恢复提交按钮为激活状态
                    this.isInitializing = true
                }
            }
        }
    </script>
    <style scoped>
    
    </style>
    